import React from 'react';
import { slideWrapper } from '../components/slide';
import { PuzzleItems } from '../components/puzzle-items';
import { RoundLetters, RoundType } from '@disco/data';

import { Content } from '../components/content';
import { SlideImage } from '../components/slide-image';

export const LeonardoPuzzle3Counting = slideWrapper(
  ({ step, getImg, countingResults, countingResultsLoading }) => {
    const { answers } = step;

    return (
      <>
        <Content left={14} top={-15} yNotCenter>
          <SlideImage width="400px" src={getImg('element')} show={true} />
        </Content>
        <Content left={13} top={15} yNotCenter>
          <SlideImage width="300px" src={getImg('stojak')} show={true} />
        </Content>
        <PuzzleItems
          {...{ countingResults, countingResultsLoading, getImg, answers, letters: RoundLetters[5] }}
          smallItem
        />
      </>
    );
  },
  { countAnswersTour: RoundType.Leonardo }
);
